<template>
  <div>

    <main role="main">

      <div class="container">

        <div class="row">

          <div class="col-md-12">

            <h2 class="mb-3">
              {{ $t('text.auditLog.registerAuditLog.title') }}

            </h2>

          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <div class="card mb-3 form-condensed">
              <div class="card-body bg-light">
                <div class="row">
                  <div class="col-md-6">

                    <div class="form-group">
                      <label for="register">{{ $t('text.auditLog.registerAuditLog.register') }}</label>
                      <v-select
                          class="form-control"
                          id="register"
                          name="register"
                          label="name"
                          :options="registerOptions"
                          :reduce="item => item.id"
                          v-model="selectedRegisterOption"
                      >
                        <span slot="no-options">{{ $t('text.globals.noOptions') }}</span>
                      </v-select>
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="uporabnik">{{$t('text.auditLog.user')}}</label>

                      <input type="text" class="form-control" id="uporabnik"
                             v-model="uporabnik"
                             :placeholder="$t('text.auditLog.enterValue')"
                      >
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="dateFrom">{{ $t('text.auditLog.dateFrom') }}</label>

                      <VueCtkDateTimePicker id="dateFrom" format="YYYY-MM-DD HH:mm:ss"
                                            :range="false"
                                            :no-label="true"
                                            :auto-close="false"
                                            formatted="DD.MM.YYYY, HH:mm"
                                            v-model="dateFrom"
                                            :only-date="false"
                                            :custom-shortcuts="customShortcuts"
                                            :locale="$t('text.globals.datePickerLocale')"
                                            :button-now-translation="$t('text.globals.now')"

                      />
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="dateFrom">{{ $t('text.auditLog.dateTo') }}</label>

                      <VueCtkDateTimePicker id="dateTo" format="YYYY-MM-DD HH:mm:ss"
                                            :range="false"
                                            :no-label="true"
                                            :auto-close="false"
                                            formatted="DD.MM.YYYY, HH:mm"
                                            v-model="dateTo"
                                            :only-date="false"
                                            :custom-shortcuts="customShortcuts"
                                            :locale="$t('text.globals.datePickerLocale')"
                                            :button-now-translation="$t('text.globals.now')"
                      />
                    </div>
                  </div>
                </div>


                <div class="row mt-2">
                  <div class="col-md-12 text-right">
                    <b-button :disabled="selectedRegisterOption === null" class="btn btn-primary text-white" @click="searchExternalLog(null)"><i
                        class="fa fa-search"></i> {{ $t('text.globals.search') }}</b-button>
                  </div>
                </div>
              </div>
            </div>


            <div class="table-responsive">

              <loading :active.sync="isLoading"
                       :can-cancel="false"
                       :is-full-page="false"></loading>

              <AudiLogRegisterTable :entries="entries" :serverParams="serverParams" :selectedRegisterOption="selectedRegisterOption"
                                    :totalElements="totalElements"></AudiLogRegisterTable>

            </div>
          </div>
        </div>

      </div>

    </main>

  </div>
</template>

<script type="text/javascript">
import Vue from 'vue';
import axios from 'axios';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import AudiLogRegisterTable from "../components/AudiLogRegisterTable";

export default {
  name: 'AuditLogExternal',
  components: {
    Loading,
    vSelect,
    AudiLogRegisterTable,
  },

  data() {
    return {
      uuid: this.$route.params.uuid ? this.$route.params.uuid : null,
      uporabnik: null,
      externalSystemId: null,
      isLoading: false,
      dateFrom: null, //this.moment().subtract(1, 'hours').format('YYYY-MM-DD HH:mm:ss'),
      dateTo: null, //this.moment().format('YYYY-MM-DD HH:mm:ss'),
      selectedItemIndex: null,
      serverParams: {
        pageNumber: 1,
        pageSize: 10,
        offset: 0,
      },
      totalElements: 0,
      perPage: null,
      entries: [],
      customShortcuts: this.$t('text.globals.customDatePickerShortcuts'),
      allMetadataOptions: [],
      registerOptions: this.$t('text.registry.registerOptions'),
      selectedRegisterOption: null
    };
  },

  computed: {},

  mounted() {
    const _this = this;

  },

  methods: {
    searchExternalLog(sortParams) {
      const _this = this;

      _this.isLoading = true;

      let registerAuditLogUrl = config.codeLists + _this.selectedRegisterOption;


      axios.get(registerAuditLogUrl + '/audit', {
        params: {
          user: _this.uporabnik ? _this.uporabnik : null,
          dateFrom: _this.dateFrom ? this.moment(_this.dateFrom, 'YYYY-MM-DD HH:mm:ss').valueOf() : null,
          dateTo: _this.dateTo ? this.moment(_this.dateTo, 'YYYY-MM-DD HH:mm:ss').valueOf() : null,
          rows: _this.serverParams.pageSize,
          skip: (_this.serverParams.pageNumber - 1) * _this.serverParams.pageSize,
          order: sortParams
        },
        method: 'GET'
      })

          .then((res) => {

            console.log("RESPONSE ", res);
            _this.entries = res.data.body.content;
            _this.serverParams.pageNumber = res.data.body.pageable.offset / res.data.body.pageable.pageSize + 1;
            _this.serverParams.pageSize = res.data.body.pageable.pageSize;
            _this.serverParams.offset = res.data.body.pageable.offset;
            _this.totalElements = res.data.body.totalElements;
            _this.isLoading = false;

          })
          .catch((error) => {
            console.error(error);
            _this.isLoading = false;


          });
    },


    onPageChange(params) {
      const _this = this;

      _this.isLoading = true;

      console.log("onPageChange externalAuditLog: ", params);

      _this.serverParams.pageNumber = params;
      setTimeout(function () {
        _this.searchExternalLog();
      }, 1)


    },

    onSortChange(sortParams) {
      const _this = this;
      _this.searchExternalLog(sortParams);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/RegisterAuditLog.vue